/**
 * iDiamonds — ambalajul premium pentru produsele din magazin.
 *
 * 1. O singură bifă, ca la gravură și garanție. Ambalajul standard e inclus și
 *    nu se afișează: „standard" înseamnă bifa nepusă.
 * 2. La submit-ul formularului de produs (capture, ca în custom-engraving.js)
 *    reține varianta de ambalaj, varianta părinte și cantitatea.
 * 3. După ce produsul intră în coș (eveniment `product-ajax:added`), adaugă
 *    produsul-taxă ca linie separată, legată prin `_pentru_varianta`.
 *
 * Condiția de adăugare e scrisă pe preț, nu pe numele variantei: o variantă de
 * ambalaj ajunsă din greșeală la 0 lei nu produce o linie de 0 lei în coș.
 *
 * Bifa nu are atribut `name`, exact ca la gravură: formularul de produs se
 * serializează cu `new FormData(form)`, iar un câmp fără nume nu ajunge
 * niciodată proprietate pe linia bijuteriei.
 *
 * Fără localStorage: în preview/theme editor storefront-ul rulează în iframe
 * unde localStorage poate fi blocat.
 */
class PackagingOption extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.productTitle = this.dataset.productTitle;
    this.input = this.querySelector('.packaging-option__input');

    if (!this.form || !this.input) return;

    this.pending = null;

    this._onSubmit = this._onSubmit.bind(this);
    this._onProductAdded = this._onProductAdded.bind(this);

    this.form.addEventListener('submit', this._onSubmit, true);
    document.addEventListener('product-ajax:added', this._onProductAdded);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this._onSubmit, true);
    document.removeEventListener('product-ajax:added', this._onProductAdded);
  }

  _parentVariantId() {
    const idInput = this.form.querySelector('[name="id"]');
    return idInput ? String(idInput.value) : '';
  }

  _quantity() {
    const qtyInput = this.form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  _onSubmit() {
    // Se resetează la fiecare încercare de adăugare în coș.
    this.pending = null;
    if (!this.input.checked) return;

    const price = parseInt(this.input.dataset.price, 10);
    if (!Number.isFinite(price) || price <= 0) return;

    const parentVariantId = this._parentVariantId();
    if (!parentVariantId) return;

    this.pending = { parentVariantId, quantity: this._quantity() };
  }

  _onProductAdded() {
    if (!this.pending) return;
    const { parentVariantId, quantity } = this.pending;
    this.pending = null;
    this._addPackaging(parentVariantId, quantity);
  }

  async _addPackaging(parentVariantId, quantity) {
    try {
      await window.iDiamonds.linkedItems.add({
        variantId: this.input.value,
        quantity,
        properties: {
          'Pentru produsul': this.productTitle,
          _pentru_varianta: parentVariantId,
        },
      });
      this.input.checked = false;
    } catch (error) {
      console.error('Ambalaj — adăugare eșuată:', error);
    }
  }
}

if (!customElements.get('packaging-option')) {
  customElements.define('packaging-option', PackagingOption);
}
